import { Blockquote, Inset, Text } from "@radix-ui/themes";


export default function Y2025M03D28() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>

          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2025-03-28.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                Photo by Amanda Viana
              </Text>
            </Inset>
          </div>

          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                    28-30 March 2025, Labyrinth, Zagarolo (Italy)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Workshop: <i>Field Perception and the Relational Unconscious: A Transversal Approach to Traditional Cultures</i>
                  </Blockquote>
                  <Blockquote size="2" color>
                    <b>Project Animism in Practice</b>
                  </Blockquote>
                  <Blockquote size="2" color>
                    Center Interstices in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    The “practice of animism” is an art of living based on a solid transmission of knowledge and collective practices developed by cultures characterized in the past as "primitive" or "barbarous". These cultures teach us not only different parameters of perception and cognition but also a form of animism that can be taken as an antidote to many of the problems we are facing today (from somatic and psychological to ecological and spiritual). This workshop proposes a reeducation of perception and a reframing of our cognitive parameters through the pluriverse of certain non-Western local traditions, as well as a reconsideration of new concepts in Western psychology and anthropology (like "extraneous knowledge", "archetypal field", "mechanism of influence", and "ontological shock") to rethink the self-referential framework of Western culture and its universalist project.
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
